import { Box, Flex, themedColor } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import type React from 'react';
import Marquee from 'react-fast-marquee';
import styled from 'styled-components';
import A21SvgIcon from './icons/A21SvgIcon';
import AlcuSvgIcon from './icons/AlcuSvgIcon';
import AliForneySvgIcon from './icons/AliForneySvgIcon';
import AmericanForestSvgIcon from './icons/AmericanForestSvgIcon';
import AmericanHeartAssociationSvgIcon from './icons/AmericanHeartAssociationSvgIcon';
import BcrfSvgIcon from './icons/BcrfSvgIcon';
import BestBuddiesSvgIcon from './icons/BestBuddiesSvgIcon';
import BornThisWaySvgIcon from './icons/BornThisWaySvgIcon';
import CfrnSvgIcon from './icons/CfrnSvgIcon';
import CharityWaterSvgIcon from './icons/CharityWaterSvgIcon';
import CodeToInspireSvgIcon from './icons/CodeToInspireSvgIcon';
import CrisisTextLineSvgIcon from './icons/CrisisTextLineSvgIcon';
import CycleForSurvivalSvgIcon from './icons/CycleForSurvivalSvgIcon';
import DirectReliefSvgIcon from './icons/DirectReliefSvgIcon';
import EarthDaySvgIcon from './icons/EarthDaySvgIcon';
import EmmasTorchSvgIcon from './icons/EmmasTorchSvgIcon';
import FeedingAmericaSvgIcon from './icons/FeedingAmericaSvgIcon';
import FosterLoveSvgIcon from './icons/FosterLoveSvgIcon';
import GurlsTalkSvgIcon from './icons/GurlsTalkSvgIcon';
import HabitatSvgIcon from './icons/HabitatSvgIcon';
import LoveOnHerArmsSvgIcon from './icons/LoveOnHerArmsSvgIcon';
import MalalaSvgIcon from './icons/MalalaSvgIcon';
import MarchForOurLivesSvgIcon from './icons/MarchForOurLivesSvgIcon';
import NamiSvgIcon from './icons/NamiSvgIcon';
import NbcSvgIcon from './icons/NbcSvgIcon';
import ObjectiveZeroSvgIcon from './icons/ObjectiveZeroSvgIcon';
import OceanAgencySvgIcon from './icons/OceanAgencySvgIcon';
import PencilsOfPromiseSvgIcon from './icons/PencilsOfPromiseSvgIcon';
import RedCrossSvgIcon from './icons/RedCrossSvgIcon';
import RobinHoodSvgIcon from './icons/RobinHoodSvgIcon';
import ShatterProofSvgIcon from './icons/ShatterProofSvgIcon';
import SpcaSvgIcon from './icons/SpcaSvgIcon';
import TeachForAmericaSvgIcon from './icons/TeachForAmericaSvgIcon';
import ThisWaySvgIcon from './icons/ThisWaySvgIcon';
import ThornSvgIcon from './icons/ThornSvgIcon';
import ThreeFiftySvgIcon from './icons/ThreeFiftySvgIcon';
import TnSvgIcon from './icons/TnSvgIcon';
import TrevorSvgIcon from './icons/TrevorSvgIcon';
import UnicefSvgIcon from './icons/UnicefSvgIcon';
import VivaConAguaSvgIcon from './icons/VivaConAguaSvgIcon';
import WinSvgIcon from './icons/WinSvgIcon';
import YouthSpeaksSvgIcon from './icons/YouthSpeaksSvgIcon';

const StyledContainer = styled(Box)``;

const StyledRow = styled(Flex)`
  align-items: center;

  ${MEDIA_QUERIES.mobile`
        margin-bottom: 16px;
        gap: 0 30px;
        margin-right: 30px;
    `}

  ${MEDIA_QUERIES.tabletAndDesktop`
        margin-bottom: 36px;
        gap: 0 50px;
        margin-right: 50px;
    `}

    @media (min-width: 1920px) {
    margin-bottom: 56px;
    gap: 0 90px;
  }

  svg {
    fill: ${themedColor('veryLightGrey')};
    transition: all 500ms ease-in-out;

    ${MEDIA_QUERIES.mobile`
            height: 80px;
            width: 120px;
        `}

    ${MEDIA_QUERIES.tabletAndDesktop`
            height: 100px;
            width: 150px;
        `}

        @media (min-width: 1920px) {
      height: 150px;
      width: 180px;
    }

    &:hover {
      fill: ${themedColor('night')};
    }
  }
`;

const Giveback2022LogoSection: React.FC = () => {
  return (
    <StyledContainer mt={[55, 70, 80]}>
      <Marquee speed={50} gradient={false} direction="left">
        <StyledRow>
          <GurlsTalkSvgIcon />
          <AmericanHeartAssociationSvgIcon />
          <AlcuSvgIcon />
          <RobinHoodSvgIcon />
          <CharityWaterSvgIcon />
          <YouthSpeaksSvgIcon />
          <ShatterProofSvgIcon />
          <TrevorSvgIcon />
          <TeachForAmericaSvgIcon />
          <BestBuddiesSvgIcon />
          <NbcSvgIcon />
        </StyledRow>
      </Marquee>
      <Marquee speed={50} gradient={false} direction="right">
        <StyledRow>
          <BcrfSvgIcon />
          <MalalaSvgIcon />
          <WinSvgIcon />
          <MarchForOurLivesSvgIcon />
          <RedCrossSvgIcon />
          <CfrnSvgIcon />
          <PencilsOfPromiseSvgIcon />
          <HabitatSvgIcon />
          <CycleForSurvivalSvgIcon />
          <OceanAgencySvgIcon />
        </StyledRow>
      </Marquee>
      <Marquee speed={50} gradient={false} direction="left">
        <StyledRow>
          <EmmasTorchSvgIcon />
          <FeedingAmericaSvgIcon />
          <ThornSvgIcon />
          <BornThisWaySvgIcon />
          <LoveOnHerArmsSvgIcon />
          <ThreeFiftySvgIcon />
          <UnicefSvgIcon />
          <NamiSvgIcon />
          <ObjectiveZeroSvgIcon />
          <EarthDaySvgIcon />
        </StyledRow>
      </Marquee>
      <Marquee speed={50} gradient={false} direction="right">
        <StyledRow>
          <FosterLoveSvgIcon />
          <SpcaSvgIcon />
          <TnSvgIcon />
          <ThisWaySvgIcon />
          <CrisisTextLineSvgIcon />
          <AliForneySvgIcon />
          <DirectReliefSvgIcon />
          <VivaConAguaSvgIcon />
          <AmericanForestSvgIcon />
          <A21SvgIcon />
          <CodeToInspireSvgIcon />
        </StyledRow>
      </Marquee>
    </StyledContainer>
  );
};

export default Giveback2022LogoSection;
